<template>
<v-main>
    <component :is="formComponent" ></component>
</v-main>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../../lang";
    import {MyResignSalaryItem} from "../../lib/api/api_response_type";
    import SalaryResign1 from "./salary_resign_1.vue";
    import SalaryResign2 from "./salary_resign_2.vue";
    import SalaryResign3 from "./salary_resign_3.vue";
    import SalaryResign4 from "./salary_resign_4.vue";
    import SalaryResign5 from "./salary_resign_5.vue";
    import SalaryResign6 from "./salary_resign_6.vue";
    import SalaryResign7 from "./salary_resign_7.vue";
    let text = new lang(0);

    export default Vue.extend({
        components:{
            SalaryResign1,
            SalaryResign2,
            SalaryResign3,
            SalaryResign4,
            SalaryResign5,
            SalaryResign6,
        },
        data: () => ({
            text : text.Text,
            formComponent:{},
        }),
        mounted(){
            this.$emit("eMounted");
        },
        methods:{
            updateInfo(type:number,dataInfo:MyResignSalaryItem){
                if(type === 1){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign1;
                }
                if(type === 2){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign2;
                }
                if(type === 3){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign3;
                }
                if(type === 4){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign4;
                }
                if(type === 5){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign5;
                }
                if(type === 6){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign6;
                }
                if(type === 7){
                    this.$store.commit("setResinData",dataInfo);
                    this.formComponent = SalaryResign7;
                }
            }
        }
    });
</script>
